import { createColumnHelper } from '@tanstack/react-table';
import { SsoOpenIdConnectionResultDomain } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Table, TableProvider, Tag, useTableState } from '@optimus-web/core';

export interface SsoDetailsPanelUserDomainsProps {
    data: SsoOpenIdConnectionResultDomain[];
}

export function SsoDetailsPanelUserDomains({ data = [] }: SsoDetailsPanelUserDomainsProps) {
    const [tableState, setTableState] = useTableState<SsoOpenIdConnectionResultDomain>({
        pagination: { show: false },
    });

    return (
        <TableProvider columns={columnsUserDomains} state={tableState} onStateChange={setTableState} as="div">
            <Table uniqueRowId="domain" amountOfRows={data.length} data={data} fixedFirstColumn fixedHeader />
        </TableProvider>
    );
}

const columnHelper = createColumnHelper<SsoOpenIdConnectionResultDomain>();

const columnsUserDomains = [
    columnHelper.accessor('domain', {
        id: 'domain',
        header: () => <LocalizedText textKey={TextKey.SsoSetupDomainName} />,
        cell: ({ getValue }) => getValue(),
    }),
    columnHelper.accessor('enforceSingleSignOn', {
        header: () => <LocalizedText textKey={TextKey.SsoSetupDomainRequired} />,
        cell: ({ getValue }) => {
            const isEnabled = getValue();
            return (
                <Tag variant={isEnabled ? 'success' : 'basicSubtle'}>
                    <LocalizedText textKey={isEnabled ? TextKey.Required : TextKey.Optional} />
                </Tag>
            );
        },
    }),
];
